export const plans = [
  {
    titulo: 'Esencial',
    detalle:[
      {
        desc:'Suma asegurada: ',
        valor:'$100 millones',
      },
      {
        desc:'Nivel hospitalario: ',
        valor:'AMPLIO',
      },
      {
        desc:'Deducible: ',
        valor:'$10,000',
      },
      {
        desc:'Coaseguro: ',
        valor:'10%',
      },
      {
        desc:'Tope coaseguro: ',
        valor:'$60,000',
      },
    ]
  },
  {
    titulo: 'Protegido',
    detalle:[
      {
        desc:'Suma asegurada: ',
        valor:'$100 millones',
      },
      {
        desc:'Nivel hospitalario: ',
        valor:'AMPLIO',
      },
      {
        desc:'Deducible: ',
        valor:'$30,000',
      },
      {
        desc:'Coaseguro: ',
        valor:'10%',
      },
      {
        desc:'Tope coaseguro: ',
        valor:'$60,000',
      }
    ]
  },
  {
    titulo: 'Protegido +',
    detalle:[
      {
        desc:'Suma asegurada: ',
        valor:'$100 millones',
      },
      {
        desc:'Nivel hospitalario: ',
        valor:'AMPLIO',
      },
      {
        desc:'Deducible: ',
        valor:'$30,000',
      },
      {
        desc:'Coaseguro: ',
        valor:'10%',
      },
      {
        desc:'Tope coaseguro: ',
        valor:'$60,000',
      }
    ]
  },
  {
    titulo: 'Blindado',
    detalle:[
      {
        desc:'Suma asegurada: ',
        valor:'$100 millones',
      },
      {
        desc:'Nivel hospitalario: ',
        valor:'AMPLIO',
      },
      {
        desc:'Deducible: ',
        valor:'$30,000',
      },
      {
        desc:'Coaseguro: ',
        valor:'10%',
      },
      {
        desc:'Tope coaseguro: ',
        valor:'$60,000',
      }
    ]
  },
]